import { render, staticRenderFns } from "./AssignEmployeeApprover.vue?vue&type=template&id=68432119&"
import script from "./AssignEmployeeApprover.vue?vue&type=script&lang=js&"
export * from "./AssignEmployeeApprover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports